import React, { useContext } from 'react';
import { LiveAriaContext } from '@shared_modules/live-aria-a11y/LiveAria';

export const LiveAriaMessage = () => {
  const { ariaText, key } = useContext(LiveAriaContext);

  return (
    <div className="LiveAriaWrapper" role="status" aria-live="polite" aria-atomic="true" key={key}>
      <span data-testid="aria-live-text">{ariaText}</span>
    </div>
  );
};

